module.exports = __webpack_public_path__ + "media/images/salomon_banner/banner__sponsor__sidebar--left-7f39298af63dd92e50cfe4ea235ba32d.jpg";